import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { RecapitoAnagrafeDTO } from "@app/shared/dto/anagrafe/recapito-anagrafeDTO";
import { RecapitoVO } from "@app/shared/vo/gescor/recapitoVO";

@Injectable({
    providedIn: "root"
  })
export class MapperRecapitoAnagrafe
  implements MapperInterface<RecapitoAnagrafeDTO, RecapitoVO> {
  convertVoToDto(recapitoVO: RecapitoVO): RecapitoAnagrafeDTO {
    throw new Error("Method not implemented.");
  }

  convertDtoToVo(recapitoDTO: RecapitoAnagrafeDTO): RecapitoVO {
    console.log("recapitoDTO.idSoggetto: ", recapitoDTO.idSoggetto);
    const recapitoVO = new RecapitoVO();
    recapitoVO.denominazioneSoggetto = recapitoDTO.denominazioneSoggetto;
    recapitoVO.denominazioneRecapito = recapitoDTO.denominazione;
    recapitoVO.idRecapito = recapitoDTO.id;
    recapitoVO.idSoggetto = recapitoDTO.idSoggetto;
    recapitoVO.tipoSoggetto = recapitoDTO.tipoSoggetto.toString();
    recapitoVO.tipo = recapitoDTO.tipo;
    recapitoVO.stato = recapitoDTO.stato;
    return recapitoVO || new RecapitoVO();
  }

  convertListVoToDto(recapitoVOList: RecapitoVO[]): RecapitoAnagrafeDTO[] {
    throw new Error("Method not implemented.");
  }

  convertListDtoToVo(recapitoDTOList: RecapitoAnagrafeDTO[]): RecapitoVO[] {
    throw new Error("Method not implemented.");
  }
}
